import { convertTimeFrom24To12 } from "utils/hooks/useMoment";
import { PropertiesType } from "utils/Types";
import { useTranslation } from "react-i18next";

type ImportantNotesType = {
  properties: PropertiesType;
  isResponsive: boolean;
};

const ImportantNotes: React.FC<ImportantNotesType> = ({ properties, isResponsive }) => {
  const { t } = useTranslation();

  return (
    <>
      {!isResponsive && <h1 className="display-lar-typo text-center">{t("maintenance.title")}</h1>}
      <p>
        {t("maintenance.placeholder", {
          endTime: convertTimeFrom24To12(properties.maintenanceEndTime)
        })}
      </p>
    </>
  );
};

export default ImportantNotes;
